import React from 'react';

export const Splash = () => {
  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <div className="d-flex justify-content-center align-items-center vh-100 w-100">
        <div
          className="p-4 shadow-lg d-flex flex-column justify-content-between h-100 w-100"
          style={{
            background: 'white',
            backgroundImage: `url("images/splash/splash-bg.png")`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          {/* You can add a top element here if needed */}
          <div className="mt-auto text-white">
            <div className="mb-2 position-relative" style={{zIndex: 1}}>
              <h1 className="fw-bold mb-3" style={{fontSize: '30px', width: '80%'}}>
                Sign up & start earning today!
              </h1>
              <p className="mb-3 text-white" style={{fontSize: '14px'}}>
                Join the Mapex ecosystem today & start earning 1.5% daily returns
              </p>

              <div className="d-flex gap-3">
                <button
                  className="btn btn-primary rounded-pill fw-semibold"
                  style={{
                    backgroundColor: '#3626a7',
                    border: 'none',
                    minWidth: '140px',
                    fontSize: '14px',
                    color: 'white',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    window.location.href = '/register';
                  }}
                >
                  Sign Up
                </button>

                <button
                  className="btn rounded-pill fw-semibold"
                  style={{
                    borderColor: '#2E2CB2',
                    minWidth: '140px',
                    fontSize: '14px',
                    color: 'white',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                  // onMouseEnter={() => setIsHovered(true)}
                  // onMouseLeave={() => setIsHovered(false)}
                  onClick={() => {
                    window.location.href = '/login';
                  }}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
